import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

@Component({
  selector: 'app-verify-button',
  templateUrl: './verify-button.component.html'
})
export class VerifyButtonComponent implements OnDestroy {
  @Input() cooldownSeconds = 30;
  @Input() buttonClass = 'btn btn-sm bg-warning mx-2';
  @Output() verify = new EventEmitter<void>();

  remainingSeconds = 0;
  private intervalId: any;

  get isDisabled(): boolean {
    return this.remainingSeconds > 0;
  }

  onClick(): void {
    if (this.isDisabled) {
      return;
    }

    this.verify.emit();
    this.startCooldown();
  }

  private startCooldown(): void {
    this.remainingSeconds = this.cooldownSeconds;

    this.intervalId = setInterval(() => {
      this.remainingSeconds--;

      if (this.remainingSeconds <= 0) {
        clearInterval(this.intervalId);
        this.remainingSeconds = 0;
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
